const siteConfigs = {
    playStoreLink: "https://play.google.com/store/apps/details?id=com.goosoft.hrplusapp",
    appleStoreLink: "https://apps.apple.com/in/app/hrplus/id1551100306",
    phoneRegExp:  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
    // apiEndPoint: 'http://localhost:3002/api/v1/',
    apiEndPoint: 'https://api.hrplusapp.com/api/v1/',
}

export default siteConfigs